import { QrReader } from "react-qr-reader"
import { observer, useLocalObservable } from "mobx-react-lite"

interface IResult {
	getText: () => string
	// format: number
	// numBits: number
	// rawBytes: Uint8Array
	// resultMetadata: Map<number, (number | string)[]>
	// resultPoints: unknown
	// text: string
	// timestamp: number
}

interface IQrScannerProps {
	onResult: (result: string) => void
}

export const QrScanner = observer(({ onResult }: IQrScannerProps) => {
	const store = useLocalObservable(() => ({
		error: null as Error | null,
		result: null as string | null,

		handleOnResult(result?: IResult | null, error?: Error | null) {
			if (error) {
				this.error = error
				return
			}

			if (result) {
				this.result = result.getText()
				onResult(this.result.trim())
				return
			}
		},
	}))

	return (
		<QrReader
			scanDelay={100}
			// eslint-disable-next-line @typescript-eslint/unbound-method
			onResult={store.handleOnResult}
			constraints={{ facingMode: "environment" }}
			containerStyle={{ width: "100vw" }}
		/>
	)
})
